import { createStore } from "vuex";
// import notifications from "./modules/notifications";
const pathLang = (window.location.pathname.split("/")[1] || "").toLowerCase();
const urlLang = pathLang === "en" || pathLang === "fr" ? pathLang : "";
const saved = localStorage.getItem("locale") || "";
const initialLang = urlLang || saved || "fr";
const store = createStore({
  state: {
    langue: initialLang,
    isEditMode: false,
  },
  mutations: {
    setLangue(state, langue) {
      state.langue = langue;
      localStorage.setItem("locale", langue); // Sauvegarde dans le localStorage
    },
    TOGGLE_EDIT_MODE(state, payload) {
      console.log("Changement de mode d'édition :", payload);
      state.isEditMode = payload;
    }    
  },
  actions: {
    changeLangue({ commit }, langue) {
      commit("setLangue", langue);
    },
    toggleEditMode({ commit }, payload) {
      commit("TOGGLE_EDIT_MODE", payload);
    },
  },
  getters: {
    getLangue: (state) => state.langue,
    isEditMode: (state) => state.isEditMode,
  },
    modules: {
  },
});

export default store;
